import { GroupsV2Api, RoleBindingDto } from '../../../api-client';
import { useQuery, UseQueryOptions, UseQueryResult } from 'react-query';
import { ErrorResponse } from '../../../common/types/errorRespose';

export const useGetGroupRoles = (
  groupsApi: GroupsV2Api,
  groupId: string,
  options?: Omit<
    UseQueryOptions<RoleBindingDto[], ErrorResponse>,
    "queryKey" | "queryFn"
    >,
): UseQueryResult<RoleBindingDto[]> => {
  const tenantId = localStorage.getItem('tenantId') as string;

  return useQuery(
    [`group-${groupId}-roles`],
    async () => groupsApi.getGroupRoles(tenantId, groupId).then(({ data }) => data),
    options,
  );
};
